module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-form-group', {
    attrs: {
      "label": "Show as:"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: 'Modal',
        value: true
      }, {
        text: 'Inline',
        value: false
      }]
    },
    model: {
      value: (_vm.showAsModal),
      callback: function($$v) {
        _vm.showAsModal = $$v
      },
      expression: "showAsModal"
    }
  })], 1), _vm._v(" "), (_vm.showAsModal) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n    Launch Form from JSON\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showAsModal && _vm.formConfig.fields) ? _c('common-modal', {
    attrs: {
      "show": _vm.showModal,
      "title": _vm.formConfig.formTitle,
      "fields": _vm.formConfig.fields,
      "initial-data": _vm.formData
    },
    on: {
      "update:show": function($event) {
        _vm.showModal = $event
      },
      "submit": _vm.handleSubmit
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showAsModal && _vm.formConfig.fields) ? _c('dynamic-form', {
    attrs: {
      "fields": _vm.formConfig.fields,
      "initial-data": _vm.formConfig.initialData,
      "title": _vm.formConfig.formTitle
    },
    on: {
      "submit": _vm.handleSubmit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bc46fb7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/JsonFormLoader.vue
// module id = 2719
// module chunks = 0